export function PageLoader() {
  return (
    <output className="flex min-h-screen items-center justify-center">
      <div className="border-primary h-10 w-10 animate-spin rounded-full border-4 border-t-transparent" />
    </output>
  );
}
